export default "__VITE_ASSET__DC6SnA3U__"